import i18next from "i18next";
import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";

import { useClient } from "utils/client";
import { ControlContext } from "context/Controls";
import { TrackingContext } from "context/Tracking";

import { getAIRiskApi } from "../api";
import { AIRiskSession } from "../types";
import { AI_RISK_SESSION_QUERY_KEY } from "./sessionCache";

// DELETE / — discards the session (accepted risks stay untouched). The cache
// is set to null so the page falls back to the start view immediately.
export const useDiscardAIRiskSession = (projectId: string) => {
  const client = useClient();
  const queryClient = useQueryClient();
  const { track } = useContext(TrackingContext);
  const { displayNotification } = useContext(ControlContext);

  return useMutation<void, Error, void>(
    () => getAIRiskApi(client).discardSession(projectId),
    {
      onSuccess: () => {
        queryClient.setQueryData<AIRiskSession | null>(
          [AI_RISK_SESSION_QUERY_KEY, projectId],
          null
        );

        track("ai risk: session discarded");
      },
      onError: (error) =>
        displayNotification!(
          i18next.t("risks.ai.errors.saveFailed"),
          error.message,
          "error"
        ),
    }
  );
};
